/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@carbon/icon-helpers';
import 'prop-types';

var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _circle7, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _circle8, _circle9, _circle10, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _circle11, _circle12, _circle13, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _circle14, _circle15, _circle16, _path209, _path210, _path211, _path212, _path213, _path214, _circle17, _circle18, _circle19, _circle20, _circle21, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _path228, _path229, _path230, _path231, _path232;
const OverflowMenuHorizontal = /*#__PURE__*/React.forwardRef(function OverflowMenuHorizontal(_ref, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "16",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OverflowMenuHorizontal.propTypes = iconPropTypes;
}
const OverflowMenuVertical = /*#__PURE__*/React.forwardRef(function OverflowMenuVertical(_ref2, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref2;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "8",
    r: "2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  OverflowMenuVertical.propTypes = iconPropTypes;
}
const Overlay = /*#__PURE__*/React.forwardRef(function Overlay(_ref3, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8ZM4,22V4H22V8H10a2.0023,2.0023,0,0,0-2,2V22Zm18,0H19.4141L10,12.586V10h2.5859l9.4153,9.4156ZM10,15.4141,16.5859,22H10ZM22.001,16.587,15.4141,10H22ZM10,28V24H22a2.0023,2.0023,0,0,0,2-2V10h4V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Overlay.propTypes = iconPropTypes;
}
const Package = /*#__PURE__*/React.forwardRef(function Package(_ref4, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref4;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H9v2H6V28H26V16H23V14h3a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20H19V22H13zM20.59 8.59L17 12.17 17 2 15 2 15 12.17 11.41 8.59 10 10 16 16 22 10 20.59 8.59z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Package.propTypes = iconPropTypes;
}
const PackageTextAnalysis = /*#__PURE__*/React.forwardRef(function PackageTextAnalysis(_ref5, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22H19V24H13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18v2h2v8c0 1.1025.8972 2 2 2h20c1.1028 0 2-.8975 2-2v-8h2v-2H2zm24 10H6v-8h20v8zM29 16h-5c-1.1025 0-2-.8975-2-2v-6c0-1.103.8975-2 2-2h5v2h-5v6h5v2zM18 6h-4v-4h-2v14h6c1.1025 0 2-.8975 2-2v-6c0-1.103-.8975-2-2-2zm-4 8v-6h4v6h-4zM8 6H3v2h5v2h-4c-1.1046 0-2 .8954-2 2v2c0 1.1046.8954 2 2 2h6V8c0-1.103-.8975-2-2-2zm0 8h-4v-2h4v2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PackageTextAnalysis.propTypes = iconPropTypes;
}
const PageFirst = /*#__PURE__*/React.forwardRef(function PageFirst(_ref6, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref6;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16L24 6 25.4 7.4 16.8 16 25.4 24.6 24 26zM8 4H10V28H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PageFirst.propTypes = iconPropTypes;
}
const PageLast = /*#__PURE__*/React.forwardRef(function PageLast(_ref7, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref7;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16L8 26 6.6 24.6 15.2 16 6.6 7.4 8 6zM22 4H24V28H22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PageLast.propTypes = iconPropTypes;
}
const PageBreak = /*#__PURE__*/React.forwardRef(function PageBreak(_ref8, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref8;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V20H2zM26 18H30V20H26zM24 22v6H8V22H6v6a2.0058 2.0058 0 002 2H24a2.0058 2.0058 0 002-2V22zM8 16V4h8v6a2.0058 2.0058 0 002 2h6v4h2V10a.9092.9092 0 00-.3-.7l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16zM18 4.4L23.6 10H18zM10 18H14V20H10zM18 18H22V20H18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PageBreak.propTypes = iconPropTypes;
}
const PageNumber = /*#__PURE__*/React.forwardRef(function PageNumber(_ref9, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref9;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26L16 26 16 20 20 20 20 18 16 18 16 16 22 16 22 22 18 22 18 24 22 24 22 26z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7,9.3l-7-7A.9078.9078,0,0,0,18,2H8A2.0059,2.0059,0,0,0,6,4V28a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V10A.9078.9078,0,0,0,25.7,9.3ZM18,4.4,23.6,10H18ZM24,28H8V4h8v6a2.0059,2.0059,0,0,0,2,2h6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PageNumber.propTypes = iconPropTypes;
}
const WatsonHealthPageScroll = /*#__PURE__*/React.forwardRef(function WatsonHealthPageScroll(_ref10, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref10;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H4a1.89,1.89,0,0,1-2-2V14a1.89,1.89,0,0,1,2-2H16a1.89,1.89,0,0,1,2,2V26A1.89,1.89,0,0,1,16,28ZM4,14V26H16V14Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22,19H20V10H10V8H20a1.89,1.89,0,0,1,2,2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14H24V6H16V4h8a1.89 1.89 0 012 2zM24 17L24 19 26.8 19 22 24.4 22 22 20 22 20 28 26 28 26 26 23.2 26 28 20.6 28 23 30 23 30 17 24 17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthPageScroll.propTypes = iconPropTypes;
}
const PaintBrush = /*#__PURE__*/React.forwardRef(function PaintBrush(_ref11, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref11;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.83,23.17,23,17.33V13a1,1,0,0,0-.29-.71l-10-10a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0,0,1.42l10,10A1,1,0,0,0,13,23h4.34l5.83,5.84a4,4,0,0,0,5.66-5.66ZM6,10.41l2.29,2.3,1.42-1.42L7.41,9,9,7.41l4.29,4.3,1.42-1.42L10.41,6,12,4.41,18.59,11,11,18.59,4.41,12Zm21.41,17a2,2,0,0,1-2.82,0l-6.13-6.12a1.8,1.8,0,0,0-.71-.29H13.41l-1-1L20,12.41l1,1v4.34a1,1,0,0,0,.29.7l6.12,6.14a2,2,0,0,1,0,2.82Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PaintBrush.propTypes = iconPropTypes;
}
const PaintBrushAlt = /*#__PURE__*/React.forwardRef(function PaintBrushAlt(_ref12, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref12;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,3.1719a4.0941,4.0941,0,0,0-5.6562,0L4.05,22.292A6.9537,6.9537,0,0,0,2,27.2412V30H4.7559a6.9523,6.9523,0,0,0,4.95-2.05L28.8281,8.8286a3.999,3.999,0,0,0,0-5.6567ZM10.91,18.26l2.8286,2.8286L11.6172,23.21,8.7886,20.3818ZM8.2915,26.5356A4.9665,4.9665,0,0,1,4.7559,28H4v-.7588a4.9671,4.9671,0,0,1,1.4644-3.5351l1.91-1.91,2.8286,2.8281ZM27.4141,7.4141,15.1528,19.6748l-2.8286-2.8286,12.2617-12.26a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PaintBrushAlt.propTypes = iconPropTypes;
}
const PalmTree = /*#__PURE__*/React.forwardRef(function PalmTree(_ref13, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref13;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.57,28C17.897,26.7251,16,22.2261,16,12v-.1313l1.1172.7446A6.4613,6.4613,0,0,1,20,18h2a8.457,8.457,0,0,0-3.7734-7.0508L16.8027,10h1.5308a7.04,7.04,0,0,1,4.2,1.4L24.4,12.8l1.2-1.6L23.7334,9.8a9.06,9.06,0,0,0-5.4-1.8H17.1172A7.0306,7.0306,0,0,1,22,6h2V4H22a9.035,9.035,0,0,0-7,3.3643A9.035,9.035,0,0,0,8,4H6V6H8a7.0306,7.0306,0,0,1,4.8828,2H11.6665a9.06,9.06,0,0,0-5.4,1.8L4.4,11.2l1.2,1.6L7.4668,11.4a7.04,7.04,0,0,1,4.2-1.4h1.5308l-1.4239.9492A8.457,8.457,0,0,0,8,18h2a6.4613,6.4613,0,0,1,2.8828-5.3867L14,11.8687V12c0,8.9438,1.4116,13.7646,2.3611,16H2v2H30V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PalmTree.propTypes = iconPropTypes;
}
const PanHorizontal = /*#__PURE__*/React.forwardRef(function PanHorizontal(_ref14, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref14;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10L22.586 11.414 26.172 15 5.828 15 9.414 11.414 8 10 2 16 8 22 9.414 20.586 5.828 17 26.172 17 22.586 20.586 24 22 30 16 24 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PanHorizontal.propTypes = iconPropTypes;
}
const PanVertical = /*#__PURE__*/React.forwardRef(function PanVertical(_ref15, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref15;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8L11.414 9.414 15 5.828 15 26.172 11.414 22.586 10 24 16 30 22 24 20.586 22.586 17 26.172 17 5.828 20.586 9.414 22 8 16 2 10 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PanVertical.propTypes = iconPropTypes;
}
const PanelExpansion = /*#__PURE__*/React.forwardRef(function PanelExpansion(_ref16, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref16;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H6A2 2 0 004 8v6a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0012 6zM6 14V8h6v6zM26 6H20a2 2 0 00-2 2V24a2 2 0 002 2h6a2 2 0 002-2V8A2 2 0 0026 6zM20 24V8h6V24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PanelExpansion.propTypes = iconPropTypes;
}
const Paragraph = /*#__PURE__*/React.forwardRef(function Paragraph(_ref17, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref17;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H13a7,7,0,0,0,0,14V28h2V6h5V28h2V6h5ZM13,16A5,5,0,0,1,13,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Paragraph.propTypes = iconPropTypes;
}
const Parameter = /*#__PURE__*/React.forwardRef(function Parameter(_ref18, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref18;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13V8a2.0023,2.0023,0,0,0-2-2H23V8h3v5a3.9756,3.9756,0,0,0,1.3823,3A3.9756,3.9756,0,0,0,26,19v5H23v2h3a2.0023,2.0023,0,0,0,2-2V19a2.0023,2.0023,0,0,1,2-2V15A2.0023,2.0023,0,0,1,28,13Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17,9l-.857,3h2L19,9h2l-.857,3H22v2H19.572l-1.143,4H21v2H17.857L17,23H15l.857-3h-2L13,23H11l.857-3H10V18h2.429l1.143-4H11V12h3.143L15,9Zm.572,5h-2l-1.143,4h2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6,13V8H9V6H6A2.0023,2.0023,0,0,0,4,8v5a2.0023,2.0023,0,0,1-2,2v2a2.0023,2.0023,0,0,1,2,2v5a2.0023,2.0023,0,0,0,2,2H9V24H6V19a3.9756,3.9756,0,0,0-1.3823-3A3.9756,3.9756,0,0,0,6,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Parameter.propTypes = iconPropTypes;
}
const ParentChild = /*#__PURE__*/React.forwardRef(function ParentChild(_ref19, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref19;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4v6a2,2,0,0,0,2,2H15v4H9a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H9V18H23v4H20a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V24a2,2,0,0,0-2-2H25V18a2,2,0,0,0-2-2H17V12ZM12,28H4V24h8Zm16,0H20V24h8ZM4,4H28v6H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ParentChild.propTypes = iconPropTypes;
}
const PartitionAuto = /*#__PURE__*/React.forwardRef(function PartitionAuto(_ref20, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref20;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19c-2.2056 0-4 1.7944-4 4 0 .6836.1882 1.3174.4917 1.8809-1.8762 1.3726-4.146 2.1191-6.4917 2.1191-6.0654 0-11-4.9346-11-11h-2c0 7.168 5.8318 13 13 13 2.8455 0 5.5923-.936 7.8433-2.6416.6235.4019 1.3613.6416 2.1567.6416 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM16 3c-2.8455 0-5.5923.936-7.8433 2.6416-.6235-.4019-1.3613-.6416-2.1567-.6416-2.2056 0-4 1.7944-4 4s1.7944 4 4 4 4-1.7944 4-4c0-.6836-.1882-1.3174-.4917-1.8809 1.8762-1.3726 4.146-2.1191 6.4917-2.1191 6.0654 0 11 4.9346 11 11h2c0-7.168-5.8318-13-13-13zM6 11c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionAuto.propTypes = iconPropTypes;
}
const PartitionCollection = /*#__PURE__*/React.forwardRef(function PartitionCollection(_ref21, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref21;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26 12c-1.8584 0-3.4106 1.2798-3.8579 3h-2.7278c-.5344 0-1.0366.208-1.4143.5859l-5.4143 5.4141H2v2h10.5857c.5344 0 1.0366-.208 1.4143-.5859l5.4143-5.4141h2.7278c.4473 1.7202 1.9995 3 3.8579 3 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM16.1717 14.5859l-3.5859-3.5859H2v-2h10.5857c.5344 0 1.0366.208 1.4143.5859l3.5859 3.5859-1.4143 1.4141z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionCollection.propTypes = iconPropTypes;
}
const PartitionRepartition = /*#__PURE__*/React.forwardRef(function PartitionRepartition(_ref22, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref22;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6c-1.8584 0-3.4106 1.2798-3.8579 3h-2.7278c-.5344 0-1.0366.208-1.4143.5859l-3.5864 3.5864 1.4141 1.4141 3.5867-3.5864h2.7278c.4473 1.7202 1.9995 3 3.8579 3 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM10.1716 17.4141l-3.5859 3.5859H2v2h4.5857c.5344 0 1.0366-.208 1.4143-.5859l3.5859-3.5859-1.4143-1.4141z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m26,18c-1.8584,0-3.4106,1.2798-3.8579,3h-2.728l-11.4141-11.4141c-.3777-.3779-.8799-.5859-1.4143-.5859H2v2h4.5859l11.4141,11.4141c.3777.3779.8799.5859,1.4143.5859h2.7278c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm0,6c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionRepartition.propTypes = iconPropTypes;
}
const PartitionSame = /*#__PURE__*/React.forwardRef(function PartitionSame(_ref23, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref23;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18c-1.8584 0-3.4106 1.2798-3.8579 3H2v2h20.1421c.4473 1.7202 1.9995 3 3.8579 3 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM26 6c-1.8584 0-3.4106 1.2798-3.8579 3H2v2h20.1421c.4473 1.7202 1.9995 3 3.8579 3 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionSame.propTypes = iconPropTypes;
}
const PartitionSpecific = /*#__PURE__*/React.forwardRef(function PartitionSpecific(_ref24, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref24;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18c-1.8584 0-3.4106 1.2798-3.8579 3h-2.728l-5.4141-5.4141c-.3777-.3779-.8799-.5859-1.4143-.5859H2v2h10.5859l5.4141 5.4141c.3777.3779.8799.5859 1.4143.5859h2.7278c.4473 1.7202 1.9995 3 3.8579 3 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM26 6c-1.8584 0-3.4106 1.2798-3.8579 3h-2.7278c-.5344 0-1.0366.208-1.4143.5859l-3.5864 3.5864 1.4141 1.4141 3.5867-3.5864h2.7278c.4473 1.7202 1.9995 3 3.8579 3 2.2056 0 4-1.7944 4-4s-1.7944-4-4-4zm0 6c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartitionSpecific.propTypes = iconPropTypes;
}
const PartlyCloudy = /*#__PURE__*/React.forwardRef(function PartlyCloudy(_ref25, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref25;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15H31V17H27z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.086 5.794H27.329V7.794H23.086z",
    transform: "rotate(-45 25.207 6.794)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H17V5H15z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M4.672 24.208H8.915V26.208H4.672z",
    transform: "rotate(-45 6.793 25.208)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M5.793 4.672H7.793V8.915H5.793z",
    transform: "rotate(-45 6.793 6.794)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15H5V17H1zM26.7939 20.3418a6.9617 6.9617 0 00-1.8681-3.2671A8.485 8.485 0 0025 16a9 9 0 10-14.585 7.0332A4.9771 4.9771 0 0015 30H25a4.9947 4.9947 0 001.7939-9.6582zM9 16a6.9955 6.9955 0 0113.9849-.2969A6.8883 6.8883 0 0020 15a7.04 7.04 0 00-6.7944 5.3418A4.986 4.986 0 0011.5618 21.39 6.9675 6.9675 0 019 16zM25 28H15a2.9945 2.9945 0 01-.6963-5.9082l.6587-.1572.0986-.67a4.9923 4.9923 0 019.878 0l.0986.6695.6587.1572A2.9945 2.9945 0 0125 28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartlyCloudy.propTypes = iconPropTypes;
}
const PartlyCloudyNight = /*#__PURE__*/React.forwardRef(function PartlyCloudyNight(_ref26, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref26;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19a4.974,4.974,0,0,0-3.2061-4.6582A6.9711,6.9711,0,0,0,13.7578,12.9a13.1418,13.1418,0,0,1,.1314-8.52A1.015,1.015,0,0,0,12.98,3a.9825.9825,0,0,0-.1746.0156A13.0958,13.0958,0,0,0,14.63,28.9971c.164.0063.3281,0,.4907,0a13.0412,13.0412,0,0,0,10.29-5.0386A4.99,4.99,0,0,0,30,19ZM14.7034,26.9976a11.0945,11.0945,0,0,1-3.201-21.584,15.1817,15.1817,0,0,0,.8443,9.3676A4.9877,4.9877,0,0,0,15,24h7.6772a11.0991,11.0991,0,0,1-7.5561,2.9976C14.9827,26.9976,14.8428,27.0024,14.7034,26.9976ZM25,22H15a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878.0005l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,25,22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PartlyCloudyNight.propTypes = iconPropTypes;
}
const Partnership = /*#__PURE__*/React.forwardRef(function Partnership(_ref27, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref27;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9a4 4 0 114-4A4 4 0 018 9zM8 3a2 2 0 102 2A2 2 0 008 3zM24 9a4 4 0 114-4A4 4 0 0124 9zm0-6a2 2 0 102 2A2 2 0 0024 3zM26 30H22a2 2 0 01-2-2V21h2v7h4V19h2V13a1 1 0 00-1-1H20.58L16 20l-4.58-8H5a1 1 0 00-1 1v6H6v9h4V21h2v7a2 2 0 01-2 2H6a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h7.58L16 16l3.42-6H27a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0126 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Partnership.propTypes = iconPropTypes;
}
const PassengerDrinks = /*#__PURE__*/React.forwardRef(function PassengerDrinks(_ref28, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref28;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4V2H22V4a3.9906 3.9906 0 003 3.8586V11H23v2h6V11H27V7.8586A3.9906 3.9906 0 0030 4zM10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4746 31.313L19.3408 24H12.2393A4.0073 4.0073 0 018.373 21.0293l-1.6337-6.126a3.8987 3.8987 0 017.5341-2.0092L15.1016 16H21v2H13.5645l-1.2227-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0052 2.0052 0 0012.2393 22h8.42l3.6543 8.5254z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H7.7683a2.0025,2.0025,0,0,1-1.9326-1.4849L2.0337,12.2576l1.9326-.5152L7.7683,26H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PassengerDrinks.propTypes = iconPropTypes;
}
const PassengerPlus = /*#__PURE__*/React.forwardRef(function PassengerPlus(_ref29, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref29;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9A3.5 3.5 0 1114 5.5 3.5042 3.5042 0 0110.5 9zm0-5A1.5 1.5 0 1012 5.5 1.5017 1.5017 0 0010.5 4zM22.4739 31.313L19.34 24H12.2385a4.0072 4.0072 0 01-3.8662-2.9707l-1.6338-6.126a3.8988 3.8988 0 017.5342-2.0092L15.1008 16H21v2H13.5637l-1.2226-4.5908a1.9 1.9 0 00-3.6709.979l1.6338 6.1255A2.0051 2.0051 0 0012.2385 22h8.42l3.6543 8.5254zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H7.7676A2.0025,2.0025,0,0,1,5.835,26.5151L2.033,12.2576l1.9326-.5152L7.7676,26H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PassengerPlus.propTypes = iconPropTypes;
}
const Password = /*#__PURE__*/React.forwardRef(function Password(_ref30, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref30;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2a8.9977,8.9977,0,0,0-8.6119,11.6118L2,24v6H8L18.3881,19.6118A9,9,0,1,0,21,2Zm0,16a7.0125,7.0125,0,0,1-2.0322-.3022L17.821,17.35l-.8472.8472-3.1811,3.1812L12.4141,20,11,21.4141l1.3787,1.3786-1.5859,1.586L9.4141,23,8,24.4141l1.3787,1.3786L7.1716,28H4V24.8284l9.8023-9.8023.8472-.8474-.3473-1.1467A7,7,0,1,1,21,18Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Password.propTypes = iconPropTypes;
}
const Paste = /*#__PURE__*/React.forwardRef(function Paste(_ref31, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref31;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H17.83l2.58-2.59L19,16l-5,5,5,5,1.41-1.41L17.83,22H26v8h2V22A2,2,0,0,0,26,20Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.71,9.29l-7-7A1,1,0,0,0,16,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2h8V28H6V4h8v6a2,2,0,0,0,2,2h6v2h2V10A1,1,0,0,0,23.71,9.29ZM16,4.41,21.59,10H16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Paste.propTypes = iconPropTypes;
}
const Pause = /*#__PURE__*/React.forwardRef(function Pause(_ref32, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref32;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
      d: "M6 4v8H4V4H6M6 3H4C3.4 3 3 3.4 3 4v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4C7 3.4 6.6 3 6 3zM12 4v8h-2V4H12M12 3h-2C9.4 3 9 3.4 9 4v8c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V4C13 3.4 12.6 3 12 3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V24H8V8h4m0-2H8A2 2 0 006 8V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2zM24 8V24H20V8h4m0-2H20a2 2 0 00-2 2V24a2 2 0 002 2h4a2 2 0 002-2V8a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pause.propTypes = iconPropTypes;
}
const PauseFilled = /*#__PURE__*/React.forwardRef(function PauseFilled(_ref33, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref33;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H10A2 2 0 008 8V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2zM22 6H20a2 2 0 00-2 2V24a2 2 0 002 2h2a2 2 0 002-2V8a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PauseFilled.propTypes = iconPropTypes;
}
const PauseOutline = /*#__PURE__*/React.forwardRef(function PauseOutline(_ref34, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref34;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
      d: "M7 5L6 5 6 11 7 11 7 5zM10 5L9 5 9 11 10 11 10 5z"
    })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10L12 10 12 22 14 22 14 10 14 10zM20 10L18 10 18 22 20 22 20 10 20 10z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PauseOutline.propTypes = iconPropTypes;
}
const PauseOutlineFilled = /*#__PURE__*/React.forwardRef(function PauseOutlineFilled(_ref35, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref35;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M7,11H6V5h1V11z M10,11H9V5h1V11z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,22H12V10h2Zm6,0H18V10h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PauseOutlineFilled.propTypes = iconPropTypes;
}
const PauseFuture = /*#__PURE__*/React.forwardRef(function PauseFuture(_ref36, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref36;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PauseFuture.propTypes = iconPropTypes;
}
const PausePast = /*#__PURE__*/React.forwardRef(function PausePast(_ref37, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref37;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11L12 11 12 22 14 22 14 11 14 11zM20 11L18 11 18 22 20 22 20 11 20 11z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,0,6,6.2343V2H4v8h8V8H7.0783A11.9818,11.9818,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PausePast.propTypes = iconPropTypes;
}
const PcnENode = /*#__PURE__*/React.forwardRef(function PcnENode(_ref38, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref38;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11L20 9 12 9 12 23 20 23 20 21 14 21 14 17 19 17 19 15 14 15 14 11 20 11z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PcnENode.propTypes = iconPropTypes;
}
const PcnMilitary = /*#__PURE__*/React.forwardRef(function PcnMilitary(_ref39, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref39;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L14.407 19 11 19.414 13.5 21.667 13 25 16 23.125 19 25 18.5 21.667 21 19.414 17.5 19 16 16z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M12.414 17.414L16 13.834 16 13.834 19.588 17.416 21 16 16 11 11 16 12.414 17.414z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M12.414 12.414L16 8.834 16 8.834 19.588 12.416 21 11 16 6 11 11 12.414 12.414z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PcnMilitary.propTypes = iconPropTypes;
}
const PcnPNode = /*#__PURE__*/React.forwardRef(function PcnPNode(_ref40, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref40;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2.002,2.002,0,0,1,2,2v5a2.002,2.002,0,0,1-2,2H14Zm0-7h4V10.9985H14Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PcnPNode.propTypes = iconPropTypes;
}
const PcnZNode = /*#__PURE__*/React.forwardRef(function PcnZNode(_ref41, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref41;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9L12 9 12 11 18 11 12 21 12 23 20 23 20 21 14 21 20 11 20 9z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4141,17.4141a1.9995,1.9995,0,0,0,0-2.8282L24.6272,8.7993l2.9006-2.8628a2.0018,2.0018,0,1,0-1.4416-1.3872L23.2129,7.3848,17.4141,1.5859a1.9995,1.9995,0,0,0-2.8282,0L8.7993,7.3726,5.9368,4.4717A2.002,2.002,0,1,0,4.55,5.9136l2.835,2.8735L1.5859,14.5859a1.9995,1.9995,0,0,0,0,2.8282l5.7989,5.7988L4.55,26.0864a1.9977,1.9977,0,1,0,1.387,1.4419l2.8625-2.9009,5.7866,5.7867a1.9995,1.9995,0,0,0,2.8282,0l5.7988-5.7989,2.8733,2.8355a1.998,1.998,0,1,0,1.4416-1.3872l-2.9006-2.8628ZM16,29,3,16,16,3,29,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PcnZNode.propTypes = iconPropTypes;
}
const Pdf = /*#__PURE__*/React.forwardRef(function Pdf(_ref42, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref42;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM8 9H2V23H4V18H8a2 2 0 002-2V11A2 2 0 008 9zm0 7H4V11H8zM16 23H12V9h4a4 4 0 014 4v6A4 4 0 0116 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pdf.propTypes = iconPropTypes;
}
const PdfReference = /*#__PURE__*/React.forwardRef(function PdfReference(_ref43, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref43;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM22 16L24 16 24 10 29 10 29 8 24 8 24 4 30 4 30 2 22 2 22 16zM16 2H12V16h4a4 4 0 004-4V6A4 4 0 0016 2zm2 10a2 2 0 01-2 2H14V4h2a2 2 0 012 2zM8 2H2V16H4V11H8a2 2 0 002-2V4A2 2 0 008 2zM8 9H4V4H8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PdfReference.propTypes = iconPropTypes;
}
const Pedestrian = /*#__PURE__*/React.forwardRef(function Pedestrian(_ref44, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref44;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6772,14l-1.2456-3.1143A2.9861,2.9861,0,0,0,17.646,9H13.5542a3.0018,3.0018,0,0,0-1.5439.4277L7,12.4336V18H9V13.5664l3-1.8V23.6973L8.5383,28.8906,10.2024,30,14,24.3027V11h3.646a.9949.9949,0,0,1,.9282.6289L20.3228,16H26V14Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M17.051 18.316L19 24.162 19 30 21 30 21 23.838 18.949 17.684 17.051 18.316zM16.5 8A3.5 3.5 0 1120 4.5 3.5042 3.5042 0 0116.5 8zm0-5A1.5 1.5 0 1018 4.5 1.5017 1.5017 0 0016.5 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pedestrian.propTypes = iconPropTypes;
}
const PedestrianFamily = /*#__PURE__*/React.forwardRef(function PedestrianFamily(_ref45, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref45;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30H17a2.0021 2.0021 0 01-2-2V23h2v5h3V23h2V19a1.0011 1.0011 0 00-1-1H12.2793l-2-6H4a1.0011 1.0011 0 00-1 1v6H5v9H9V21h2v7a2.0021 2.0021 0 01-2 2H5a2.0021 2.0021 0 01-2-2V21a2.0021 2.0021 0 01-2-2V13a3.0033 3.0033 0 013-3h6.2793a1.998 1.998 0 011.8975 1.3674L13.7207 16H21a3.0033 3.0033 0 013 3v4a2.0021 2.0021 0 01-2 2v3A2.0021 2.0021 0 0120 30zM28 30H26V19h3V13a1.0011 1.0011 0 00-1-1H24V10h4a3.0033 3.0033 0 013 3v6a2.0021 2.0021 0 01-2 2H28zM7 9a4 4 0 114-4A4.0045 4.0045 0 017 9zM7 3A2 2 0 109 5 2.0021 2.0021 0 007 3zM25 9a4 4 0 114-4A4.0045 4.0045 0 0125 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0025 3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,15A3.5,3.5,0,1,1,22,11.5,3.5041,3.5041,0,0,1,18.5,15Zm0-5A1.5,1.5,0,1,0,20,11.5,1.5017,1.5017,0,0,0,18.5,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PedestrianFamily.propTypes = iconPropTypes;
}
const PedestrianChild = /*#__PURE__*/React.forwardRef(function PedestrianChild(_ref46, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref46;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16H17.4683l-5-6H5a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21H10v7H6V19H4V13a1.0009,1.0009,0,0,1,1-1h6.5317l5,6H26a1.0009,1.0009,0,0,1,1,1v3H25v6H22V22H20v6a2.0023,2.0023,0,0,0,2,2h3a2.0023,2.0023,0,0,0,2-2V24a2.0023,2.0023,0,0,0,2-2V19A3.0033,3.0033,0,0,0,26,16Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15A3.5 3.5 0 1127 11.5 3.5042 3.5042 0 0123.5 15zm0-5A1.5 1.5 0 1025 11.5 1.5017 1.5017 0 0023.5 10zM8 9a4 4 0 114-4A4.0042 4.0042 0 018 9zM8 3a2 2 0 102 2A2.0023 2.0023 0 008 3z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PedestrianChild.propTypes = iconPropTypes;
}
const Pen = /*#__PURE__*/React.forwardRef(function Pen(_ref47, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref47;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3069,6.1069,30,3.4141,28.5859,2,25.8931,4.6929,24.8,3.6a1.9328,1.9328,0,0,0-2.8,0L4,21.6V28h6.4l18-18a1.9329,1.9329,0,0,0,0-2.8ZM9.6,26H6V22.4L23.4,5,27,8.6Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M8.136 7.5H18.863999999999997V9.5H8.136z",
    transform: "rotate(-45 13.5 8.5)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pen.propTypes = iconPropTypes;
}
const PenFountain = /*#__PURE__*/React.forwardRef(function PenFountain(_ref48, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref48;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,5.293l-3-3a.9994.9994,0,0,0-1.414,0L19.5859,8H17.0947A11.0118,11.0118,0,0,0,6.7124,15.3662L2.0562,28.67a1,1,0,0,0,1.2744,1.2739l13.3037-4.6562A11.012,11.012,0,0,0,24,14.9053V12.4141L29.707,6.707A.9994.9994,0,0,0,29.707,5.293Zm-7.414,6A1,1,0,0,0,22,12v2.9053A9.01,9.01,0,0,1,15.9731,23.4l-9.1677,3.209L16,17.4141,14.5859,16,5.3914,25.1948,8.6,16.0269A9.01,9.01,0,0,1,17.0947,10H20a1,1,0,0,0,.707-.293L26,4.4141,27.5859,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PenFountain.propTypes = iconPropTypes;
}
const Pending = /*#__PURE__*/React.forwardRef(function Pending(_ref49, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref49;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "16",
    r: "2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pending.propTypes = iconPropTypes;
}
const PendingFilled = /*#__PURE__*/React.forwardRef(function PendingFilled(_ref50, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref50;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PendingFilled.propTypes = iconPropTypes;
}
const Percentage = /*#__PURE__*/React.forwardRef(function Percentage(_ref51, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref51;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14ZM9,6a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,9,6Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0.029 15H31.97V17H0.029z",
    transform: "rotate(-45 16 16)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Percentage.propTypes = iconPropTypes;
}
const PercentageFilled = /*#__PURE__*/React.forwardRef(function PercentageFilled(_ref52, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref52;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0.029 15H31.97V17H0.029z",
    transform: "rotate(-45 16 16)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PercentageFilled.propTypes = iconPropTypes;
}
const Person = /*#__PURE__*/React.forwardRef(function Person(_ref53, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref53;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30H14a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h6a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0118 30zM13 12a.94.94 0 00-1 1v6h2v9h4V19h2V13a.94.94 0 00-1-1zM16 9a4 4 0 114-4h0A4 4 0 0116 9zm0-6a2 2 0 102 2h0a2 2 0 00-2-2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Person.propTypes = iconPropTypes;
}
const PersonFavorite = /*#__PURE__*/React.forwardRef(function PersonFavorite(_ref54, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref54;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M10 31H6a2.0059 2.0059 0 01-2-2V22a2.0059 2.0059 0 01-2-2V14a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0110 31zM5 13a.9448.9448 0 00-1 1v6H6v9h4V20h2V14a.9448.9448 0 00-1-1zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4zM28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PersonFavorite.propTypes = iconPropTypes;
}
const Pest = /*#__PURE__*/React.forwardRef(function Pest(_ref55, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref55;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "9.5",
    r: "1.5"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "13",
    r: "1"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "21",
    r: "1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M25,14a8.9844,8.9844,0,0,0-7,3.3555V13a10.9054,10.9054,0,0,0-1.0093-4.5845l-.3569-.7768L15.811,7.87A2.9549,2.9549,0,0,1,15,8a3.0033,3.0033,0,0,1-3-3,2.9574,2.9574,0,0,1,.1294-.8105l.2324-.8233-.7773-.3569A10.9115,10.9115,0,0,0,7,2H2V9a10.8954,10.8954,0,0,0,2.2339,6.627l.3887.4277.54-.0381a5.5286,5.5286,0,0,1,5.3628,3.2559l.2207.497.5376.0845A11.0219,11.0219,0,0,0,13,20h3V30h2V26h3a9.01,9.01,0,0,0,9-9V14ZM12.1016,17.9468A7.51,7.51,0,0,0,5.5283,14,8.8945,8.8945,0,0,1,4,9V4H7a8.8624,8.8624,0,0,1,3.0259.53A4.2457,4.2457,0,0,0,10,5a4.9658,4.9658,0,0,0,5.47,4.9736A8.8793,8.8793,0,0,1,16,13v5H13A8.1153,8.1153,0,0,1,12.1016,17.9468ZM28,17a7.0078,7.0078,0,0,1-7,7H18V23a7.01,7.01,0,0,1,5.0212-6.7109A1.4971,1.4971,0,1,0,26,16.5a1.485,1.485,0,0,0-.0918-.5H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pest.propTypes = iconPropTypes;
}
const WatsonHealthPetImageB = /*#__PURE__*/React.forwardRef(function WatsonHealthPetImageB(_ref56, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref56;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21H21V24H19zM19 0H21V3H19zM8 11H11V13H8zM29 11H32V13H29z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M11.59 3.07H13.57V6.07H11.59z",
    transform: "rotate(-45 12.586 4.577)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M26.44 17.92H28.42V20.92H26.44z",
    transform: "rotate(-45 27.43 19.408)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M11.09 18.42H14.09V20.400000000000002H11.09z",
    transform: "rotate(-45 12.592 19.414)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M25.93 3.58H28.93V5.5600000000000005H25.93z",
    transform: "rotate(-45 27.423 4.57)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5a7 7 0 107 7A7 7 0 0020 5zm0 12A5 5 0 0120 7zM5 18H0V32H5a3 3 0 003-3V27a3 3 0 00-.78-2A3 3 0 008 23V21A3 3 0 005 18zM2 20H5a1 1 0 011 1v2a1 1 0 01-1 1H2zm4 9a1 1 0 01-1 1H2V26H5a1 1 0 011 1zM2 2L9 2 9 0 0 0 0 9 2 9 2 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthPetImageB.propTypes = iconPropTypes;
}
const WatsonHealthPetImageO = /*#__PURE__*/React.forwardRef(function WatsonHealthPetImageO(_ref57, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref57;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M11 29H13V32H11zM11 8H13V11H11zM0 19H3V21H0zM21 19H24V21H21z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59 11.09H5.57V14.09H3.59z",
    transform: "rotate(-45 4.585 12.59)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M18.44 25.93H20.42V28.93H18.44z",
    transform: "rotate(-45 19.429 27.422)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09 26.44H6.09V28.42H3.09z",
    transform: "rotate(-45 4.591 27.428)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M17.93 11.59H20.93V13.57H17.93z",
    transform: "rotate(-45 19.423 12.585)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13a7 7 0 107 7A7 7 0 0012 13zm0 12a5 5 0 010-10zM2 2L9 2 9 0 0 0 0 9 2 9 2 2zM30 0H26a2 2 0 00-2 2V12a2 2 0 002 2h4a2 2 0 002-2V2A2 2 0 0030 0zM26 12V2h4V12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthPetImageO.propTypes = iconPropTypes;
}
const Phone = /*#__PURE__*/React.forwardRef(function Phone(_ref58, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref58;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Phone.propTypes = iconPropTypes;
}
const PhoneApplication = /*#__PURE__*/React.forwardRef(function PhoneApplication(_ref59, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref59;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20zM25 30h-.17C5.18 28.87 2.39 12.29 2 7.23A3 3 0 014.7611 4.0088Q4.88 4 5 4h5.27a2 2 0 011.86 1.26L13.65 9a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0123 18.35l3.77 1.51A2 2 0 0128 21.72V27A3 3 0 0125 30zM5 6a1 1 0 00-1.0032.9968c0 .0278.001.0555.0032.0832C4.46 13 7.41 27 24.94 28a1 1 0 001.0581-.9382Q26 27.0309 26 27V21.72l-3.77-1.51-2.87 2.85L18.88 23C10.18 21.91 9 13.21 9 13.12l-.06-.48 2.84-2.87L10.28 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneApplication.propTypes = iconPropTypes;
}
const PhoneBlock = /*#__PURE__*/React.forwardRef(function PhoneBlock(_ref60, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref60;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneBlock.propTypes = iconPropTypes;
}
const PhoneBlockFilled = /*#__PURE__*/React.forwardRef(function PhoneBlockFilled(_ref61, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref61;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneBlockFilled.propTypes = iconPropTypes;
}
const PhoneFilled = /*#__PURE__*/React.forwardRef(function PhoneFilled(_ref62, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref62;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M20.33,21.48l2.24-2.24a2.19,2.19,0,0,1,2.34-.48l2.73,1.09a2.18,2.18,0,0,1,1.36,2v5A2.17,2.17,0,0,1,26.72,29C7.59,27.81,3.73,11.61,3,5.41A2.17,2.17,0,0,1,5.17,3H10a2.16,2.16,0,0,1,2,1.36l1.09,2.73a2.16,2.16,0,0,1-.47,2.34l-2.24,2.24S11.67,20.4,20.33,21.48Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneFilled.propTypes = iconPropTypes;
}
const PhoneIncoming = /*#__PURE__*/React.forwardRef(function PhoneIncoming(_ref63, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref63;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneIncoming.propTypes = iconPropTypes;
}
const PhoneIncomingFilled = /*#__PURE__*/React.forwardRef(function PhoneIncomingFilled(_ref64, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref64;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneIncomingFilled.propTypes = iconPropTypes;
}
const PhoneIp = /*#__PURE__*/React.forwardRef(function PhoneIp(_ref65, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref65;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14H18V16H16zM20 14H22V16H20zM24 14H26V16H24zM16 18H18V20H16zM20 18H22V20H20zM24 18H26V20H24zM16 22H18V24H16zM20 22H22V24H20zM24 22H26V24H24zM16 10H26V12H16z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H14V5a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,5V6H4A2.0025,2.0025,0,0,0,2,8V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V8A2.0025,2.0025,0,0,0,28,6ZM8,5h4V22H8ZM28,26H4V8H6V22a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V8H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneIp.propTypes = iconPropTypes;
}
const PhoneOff = /*#__PURE__*/React.forwardRef(function PhoneOff(_ref66, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref66;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19 18.56A25.66 25.66 0 015 6.08V6A1 1 0 016 5h5.28l1.5 3.77L9.94 11.64l.06.48a13 13 0 001.46 4.17l1.46-1.46a9.34 9.34 0 01-.84-2.52l2.13-2.15A2 2 0 0014.65 8L13.13 4.26A2 2 0 0011.27 3H5.76A3 3 0 003 6.23 28 28 0 007.79 20zM27.77 18.86L24 17.35a2 2 0 00-2.17.41l-2.17 2.15A9.17 9.17 0 0115.45 18L30 3.41 28.59 2 2 28.59 3.41 30l7-7c3.38 3.18 8.28 5.62 15.39 6H26a3 3 0 003-3V20.72A2 2 0 0027.77 18.86zM27 26v.06a1 1 0 01-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14 19.44A10.77 10.77 0 0019.88 22l.48.06 2.87-2.85L27 20.72z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneOff.propTypes = iconPropTypes;
}
const PhoneOffFilled = /*#__PURE__*/React.forwardRef(function PhoneOffFilled(_ref67, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref67;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M26.74 19.56l-2.52-1a2 2 0 00-2.15.44L20 21.06a9.93 9.93 0 01-5.35-2.29L30 3.41 28.59 2 2 28.59 3.41 30l7.93-7.92c3.24 3.12 7.89 5.5 14.55 5.92A2 2 0 0028 26V21.41A2 2 0 0026.74 19.56zM8.15 18.19l3.52-3.52A11.68 11.68 0 0110.85 12l2.07-2.07a2 2 0 00.44-2.15l-1-2.52A2 2 0 0010.5 4H6A2 2 0 004 6.22 29 29 0 008.15 18.19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneOffFilled.propTypes = iconPropTypes;
}
const PhoneOutgoing = /*#__PURE__*/React.forwardRef(function PhoneOutgoing(_ref68, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref68;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M26,29h-0.2C6.2,27.9,3.4,11.3,3,6.2C2.9,4.6,4.1,3.1,5.8,3C5.8,3,5.9,3,6,3h5.3c0.8,0,1.6,0.5,1.9,1.3L14.6,8 c0.3,0.7,0.1,1.6-0.4,2.2l-2.1,2.1c0.7,3.9,3.7,6.9,7.6,7.6l2.2-2.1c0.6-0.6,1.4-0.7,2.2-0.4l3.8,1.5c0.7,0.3,1.2,1,1.2,1.9V26 C29,27.7,27.7,29,26,29z M6,5C5.4,5,5,5.4,5,6c0,0,0,0.1,0,0.1C5.5,12,8.4,26,25.9,27c0.6,0,1-0.4,1.1-0.9c0,0,0,0,0-0.1v-5.3 l-3.8-1.5l-2.9,2.9L19.9,22c-8.7-1.1-9.9-9.8-9.9-9.9l-0.1-0.5l2.8-2.9L11.3,5H6z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4L20 6 24.6 6 18 12.6 19.4 14 26 7.4 26 12 28 12 28 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneOutgoing.propTypes = iconPropTypes;
}
const PhoneOutgoingFilled = /*#__PURE__*/React.forwardRef(function PhoneOutgoingFilled(_ref69, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref69;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4L20 6 24.586 6 18 12.586 19.414 14 26 7.414 26 12 28 12 28 4 20 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneOutgoingFilled.propTypes = iconPropTypes;
}
const PhoneSettings = /*#__PURE__*/React.forwardRef(function PhoneSettings(_ref70, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref70;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneSettings.propTypes = iconPropTypes;
}
const PhoneVoice = /*#__PURE__*/React.forwardRef(function PhoneVoice(_ref71, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref71;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM26 29h-.17C6.18 27.87 3.39 11.29 3 6.23A3 3 0 015.7612 3.0088Q5.88 3 6 3h5.27a2 2 0 011.86 1.26L14.65 8a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0124 17.35l3.77 1.51A2 2 0 0129 20.72V26A3 3 0 0126 29zM6 5a1 1 0 00-1.0032.9968q0 .0417.0032.0832C5.46 12 8.41 26 25.94 27a1 1 0 001.0582-.9382Q27 26.0309 27 26V20.72l-3.77-1.51-2.87 2.85L19.88 22C11.18 20.91 10 12.21 10 12.12l-.06-.48 2.84-2.87L11.28 5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneVoice.propTypes = iconPropTypes;
}
const PhoneVoiceFilled = /*#__PURE__*/React.forwardRef(function PhoneVoiceFilled(_ref72, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref72;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM20.3333 21.4823l2.24-2.24a2.1667 2.1667 0 012.3368-.48l2.7281 1.0913A2.1666 2.1666 0 0129 21.8659v4.9613a2.1668 2.1668 0 01-2.2843 2.1686C7.5938 27.8054 3.7321 11.6114 3.0146 5.4079A2.162 2.162 0 015.1692 3H10.042a2.1666 2.1666 0 012.0117 1.362L13.145 7.09a2.1666 2.1666 0 01-.48 2.3367l-2.24 2.24S11.6667 20.399 20.3333 21.4823z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhoneVoiceFilled.propTypes = iconPropTypes;
}
const PhraseSentiment = /*#__PURE__*/React.forwardRef(function PhraseSentiment(_ref73, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref73;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M18.303,10a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,19l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,10Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PhraseSentiment.propTypes = iconPropTypes;
}
const PicnicArea = /*#__PURE__*/React.forwardRef(function PicnicArea(_ref74, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref74;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12a4 4 0 114-4A4.0045 4.0045 0 0124 12zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 6zM26 22H21.8472L21.18 18H24V16H8v2h2.82l-.6668 4H6v2H9.82l-.6668 4H11.18l.6668-4h8.3056l.6668 4h2.0276L22.18 24H26zM12.18 22l.6665-4h6.3062l.6665 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PicnicArea.propTypes = iconPropTypes;
}
const PiggyBank = /*#__PURE__*/React.forwardRef(function PiggyBank(_ref75, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref75;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,14H20V12H18V11H16v1.0508A2.5,2.5,0,0,0,16.5,17h1a.5.5,0,0,1,0,1H14v2h2v1h2V19.9492A2.5,2.5,0,0,0,17.5,15h-1a.5.5,0,0,1,0-1Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M29,13H26.98A5.7789,5.7789,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0926,5.0926,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.013,7.013,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PiggyBank.propTypes = iconPropTypes;
}
const PiggyBankSlot = /*#__PURE__*/React.forwardRef(function PiggyBankSlot(_ref76, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref76;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H20V13H13z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M29,13H26.98A5.7791,5.7791,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0928,5.0928,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.0129,7.0129,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PiggyBankSlot.propTypes = iconPropTypes;
}
const Pills = /*#__PURE__*/React.forwardRef(function Pills(_ref77, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref77;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.999,6.999,0,0,0,12.2855,4.5878A7.9969,7.9969,0,1,0,22,14Zm0,2a6.0046,6.0046,0,0,1,5.91,5H16.09A6.0046,6.0046,0,0,1,22,16ZM6,9A5,5,0,0,1,16,9v6H6Zm5,19a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9566,7.9566,0,0,0-.7242,8.9315A4.9885,4.9885,0,0,1,11,28Zm11,0a6.0046,6.0046,0,0,1-5.91-5H27.91A6.0046,6.0046,0,0,1,22,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pills.propTypes = iconPropTypes;
}
const PillsAdd = /*#__PURE__*/React.forwardRef(function PillsAdd(_ref78, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref78;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21L23 21 23 19 21 19 21 21 19 21 19 23 21 23 21 25 23 25 23 23 25 23 25 21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PillsAdd.propTypes = iconPropTypes;
}
const PillsSubtract = /*#__PURE__*/React.forwardRef(function PillsSubtract(_ref79, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref79;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M19 21H25V23H19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PillsSubtract.propTypes = iconPropTypes;
}
const Pin = /*#__PURE__*/React.forwardRef(function Pin(_ref80, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref80;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M28.59,13.31,30,11.9,20,2,18.69,3.42,19.87,4.6,8.38,14.32,6.66,12.61,5.25,14l5.66,5.68L2,28.58,3.41,30l8.91-8.91L18,26.75l1.39-1.42-1.71-1.71L27.4,12.13ZM16.26,22.2,9.8,15.74,21.29,6,26,10.71Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pin.propTypes = iconPropTypes;
}
const PinFilled = /*#__PURE__*/React.forwardRef(function PinFilled(_ref81, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref81;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5858,13.3137,30,11.9,20,2,18.6858,3.415l1.1858,1.1857L8.38,14.3225,6.6641,12.6067,5.25,14l5.6572,5.6773L2,28.5831,3.41,30l8.9111-8.9087L18,26.7482l1.3929-1.414L17.6765,23.618l9.724-11.4895Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PinFilled.propTypes = iconPropTypes;
}
const Plan = /*#__PURE__*/React.forwardRef(function Plan(_ref82, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref82;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M31,8c0-0.4-0.2-0.7-0.5-0.9l-7-4C23.3,3,23.2,3,23,3s-0.3,0-0.5,0.1L16,6.8L9.5,3.1C9.3,3,9.2,3,9,3S8.7,3,8.5,3.1l-7,4 C1.2,7.3,1,7.6,1,8v20c0,0.6,0.4,1,1,1c0.2,0,0.3-0.1,0.5-0.1l0,0L9,25.2l6.5,3.7C15.7,29,15.8,29,16,29s0.3,0,0.5-0.1l6.5-3.7 l6.5,3.7l0,0c0.1,0.1,0.3,0.1,0.5,0.1c0.6,0,1-0.4,1-1V8z M3,8.6l5-2.9v17.7l-5,2.9V8.6z M15,26.3l-5-2.9V5.7l5,2.9V26.3z M22,23.4 l-5,2.9V8.6l5-2.9V23.4z M24,23.4V5.7l5,2.9l0,17.7L24,23.4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Plan.propTypes = iconPropTypes;
}
const Plane = /*#__PURE__*/React.forwardRef(function Plane(_ref83, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref83;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M29.37,14.75,20,10V6a4,4,0,0,0-8,0v4L2.63,14.75a1,1,0,0,0-.63.93v5a1,1,0,0,0,1,1,1,1,0,0,0,.29-.05L12,18v5L8.55,24.72a1,1,0,0,0-.55.9V29a1,1,0,0,0,1,1,.9.9,0,0,0,.28,0L16,28l6.72,2A.9.9,0,0,0,23,30a1,1,0,0,0,1-1V25.62a1,1,0,0,0-.55-.9L20,23V18l8.71,3.61a1,1,0,0,0,.29.05,1,1,0,0,0,1-1v-5A1,1,0,0,0,29.37,14.75ZM28,19.15,18,15v9.24l4,2v1.43l-6-1.75-6,1.75V26.24l4-2V15L4,19.15V16.3l10-5.07V6a2,2,0,0,1,4,0v5.23L28,16.3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Plane.propTypes = iconPropTypes;
}
const PlanePrivate = /*#__PURE__*/React.forwardRef(function PlanePrivate(_ref84, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref84;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5845,14.585l-3.12-1.8721A4.9951,4.9951,0,0,0,22.8921,12H7.7808L7.16,9.5151A1.9975,1.9975,0,0,0,5.2192,8H4a2.0023,2.0023,0,0,0-2,2v7a3.0033,3.0033,0,0,0,3,3h7v6a2.0023,2.0023,0,0,0,2,2h1.3071A2.0086,2.0086,0,0,0,17.18,26.7021L19.6929,20h7.3916a2.9152,2.9152,0,0,0,1.5-5.415ZM27.0845,18H18.3071l-3,8H14V18H5a1.0009,1.0009,0,0,1-1-1V10H5.2192l1,4H10v2h2V14h3v2h2V14h3v2h2V14h.8921a2.9977,2.9977,0,0,1,1.5434.4277l3.12,1.8721a.9154.9154,0,0,1-.4712,1.7Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4h1.3228l2.4,6h2.1545L17.18,3.2573A1.9906,1.9906,0,0,0,15.3228,2H14a2.0023,2.0023,0,0,0-2,2v6h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlanePrivate.propTypes = iconPropTypes;
}
const PlaneSea = /*#__PURE__*/React.forwardRef(function PlaneSea(_ref85, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref85;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 30H2V28H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 28a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 28a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 28h2zM28 6v4H25.5L23.4 7.2A3.0129 3.0129 0 0021 6H15a3.0033 3.0033 0 00-3 3v1H8.6182L7.8945 8.5527l-1-2A1 1 0 006 6H3A1 1 0 002 7v6a3.0033 3.0033 0 003 3h6.82l-.6666 4H7a1 1 0 000 2H27a1 1 0 000-2H22.847L22.18 16h.1629a4.9662 4.9662 0 003.5351-1.4648L28 12.4141V16h2V6zM14 9a1.0009 1.0009 0 011-1h6a1.0045 1.0045 0 01.8.4L23 10H14zm6.82 11H13.18l.6666-4h6.306zm1.5237-6H5a1.0009 1.0009 0 01-1-1V8H5.3818l.7237 1.4473L7.3818 12h18.204l-1.1214 1.1211A2.9789 2.9789 0 0122.3433 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlaneSea.propTypes = iconPropTypes;
}
const Play = /*#__PURE__*/React.forwardRef(function Play(_ref86, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref86;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
      d: "M3.5,14C3.2,14,3,13.8,3,13.5v-11c0-0.2,0.1-0.3,0.2-0.4C3.4,2,3.6,2,3.8,2.1l9.5,5.5c0.2,0.1,0.3,0.4,0.2,0.7 c0,0.1-0.1,0.1-0.2,0.2l-9.5,5.5C3.7,14,3.6,14,3.5,14z M4,3.4v9.3L12,8L4,3.4z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28ZM8,6.6909V25.3088L24.9248,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Play.propTypes = iconPropTypes;
}
const PlayFilled = /*#__PURE__*/React.forwardRef(function PlayFilled(_ref87, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref87;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5 c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlayFilled.propTypes = iconPropTypes;
}
const PlayFilledAlt = /*#__PURE__*/React.forwardRef(function PlayFilledAlt(_ref88, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref88;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlayFilledAlt.propTypes = iconPropTypes;
}
const PlayOutline = /*#__PURE__*/React.forwardRef(function PlayOutline(_ref89, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref89;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
    })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
      d: "M6,11.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.3-0.2-0.4V5c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3 C12,7.7,12.1,8,11.9,8.2c0,0.1-0.1,0.2-0.2,0.2l-5.5,3C6.2,11.5,6.1,11.5,6,11.5z M6.5,5.8v4.3l4-2.2L6.5,5.8z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlayOutline.propTypes = iconPropTypes;
}
const PlayOutlineFilled = /*#__PURE__*/React.forwardRef(function PlayOutlineFilled(_ref90, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref90;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5 c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z"
    })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
      d: "M6.5 10.2L10.5 8 6.5 5.8z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.382L20.764 16 12 11.618 12 20.382z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlayOutlineFilled.propTypes = iconPropTypes;
}
const Playlist = /*#__PURE__*/React.forwardRef(function Playlist(_ref91, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref91;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H22V8H4zM4 12H22V14H4zM4 18H16V20H4zM21 18L28 23 21 28 21 18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Playlist.propTypes = iconPropTypes;
}
const Plug = /*#__PURE__*/React.forwardRef(function Plug(_ref92, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref92;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Zm0,8a6,6,0,0,1-12,0V10H22Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Plug.propTypes = iconPropTypes;
}
const PlugFilled = /*#__PURE__*/React.forwardRef(function PlugFilled(_ref93, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref93;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PlugFilled.propTypes = iconPropTypes;
}
const Png = /*#__PURE__*/React.forwardRef(function Png(_ref94, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref94;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 19L14.32 9 12 9 12 23 14 23 14 13 17.68 23 20 23 20 9 18 9 18 19zM4 23H2V9H8a2 2 0 012 2v5a2 2 0 01-2 2H4zm0-7H8V11H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Png.propTypes = iconPropTypes;
}
const PointOfPresence = /*#__PURE__*/React.forwardRef(function PointOfPresence(_ref95, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref95;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30H18a2.0021 2.0021 0 01-2-2V18a2.0021 2.0021 0 012-2h2v2H18V28H28V18H26V16h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM14 16H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H14a2.0021 2.0021 0 012 2V6H14V4H4V14H14V12h2v2A2.0021 2.0021 0 0114 16z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M26,9a2.9926,2.9926,0,0,0-5.8157-1H9v2H20.1843A2.9939,2.9939,0,0,0,22,11.8154V23h2V11.8159A2.9958,2.9958,0,0,0,26,9Zm-3,1a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,23,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PointOfPresence.propTypes = iconPropTypes;
}
const WatsonHealthPointerText = /*#__PURE__*/React.forwardRef(function WatsonHealthPointerText(_ref96, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref96;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M13.71 12.29L7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29zM28 30H12a2 2 0 01-2-2V18h2V28H28V12H18V10H28a2 2 0 012 2V28A2 2 0 0128 30z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthPointerText.propTypes = iconPropTypes;
}
const Police = /*#__PURE__*/React.forwardRef(function Police(_ref97, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref97;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H12V30H10z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Police.propTypes = iconPropTypes;
}
const Policy = /*#__PURE__*/React.forwardRef(function Policy(_ref98, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref98;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18A6 6 0 1020 22.46v7.54l4-1.8926 4 1.8926V22.46A5.98 5.98 0 0030 18zm-4 8.84l-2-.9467L22 26.84V23.65a5.8877 5.8877 0 004 0zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zM9 14H16V16H9zM9 8H19V10H9z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Policy.propTypes = iconPropTypes;
}
const Popup = /*#__PURE__*/React.forwardRef(function Popup(_ref99, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref99;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Popup.propTypes = iconPropTypes;
}
const PortInput = /*#__PURE__*/React.forwardRef(function PortInput(_ref100, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref100;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28c-3.5928,0-6.9666-1.5903-9.2566-4.3632l1.542-1.2737c1.9087,2.3113,4.7207,3.6368,7.7146,3.6368,5.5139,0,10-4.486,10-10s-4.4861-10-10-10c-2.9939,0-5.8059,1.3256-7.7146,3.6368l-1.542-1.2737c2.29-2.7728,5.6638-4.3632,9.2566-4.3632,6.6169,0,12,5.3832,12,12s-5.3831,12-12,12Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16L16 9 14.5859 10.4141 19.1719 15 2 15 2 17 19.1719 17 14.5859 21.5859 16 23 23 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PortInput.propTypes = iconPropTypes;
}
const PortOutput = /*#__PURE__*/React.forwardRef(function PortOutput(_ref101, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref101;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16L23 9 21.5859 10.4141 26.1719 15 9 15 9 17 26.1719 17 21.5859 21.5859 23 23 30 16z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28c-6.6167,0-12-5.3832-12-12S7.3833,4,14,4c2.335,0,4.5986,.6714,6.5461,1.9414l-1.0923,1.6753c-1.6221-1.0576-3.5078-1.6167-5.4539-1.6167-5.5139,0-10,4.486-10,10s4.4861,10,10,10c1.946,0,3.8318-.5591,5.4539-1.6167l1.0923,1.6753c-1.9475,1.27-4.2112,1.9414-6.5461,1.9414Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PortOutput.propTypes = iconPropTypes;
}
const Portfolio = /*#__PURE__*/React.forwardRef(function Portfolio(_ref102, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref102;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Portfolio.propTypes = iconPropTypes;
}
const Power = /*#__PURE__*/React.forwardRef(function Power(_ref103, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref103;
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
      d: "M11.2,2.9l-0.5,0.9c2.6,1.5,3.5,4.9,2,7.5s-4.9,3.5-7.5,2s-3.5-4.9-2-7.5c0.5-0.8,1.2-1.5,2-2L4.8,2.9 c-3.1,1.8-4.2,5.8-2.4,8.9s5.8,4.2,8.9,2.4s4.2-5.8,2.4-8.9C13.1,4.3,12.2,3.4,11.2,2.9z"
    })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
      d: "M7.5 1H8.5V8H7.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V16H15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Power.propTypes = iconPropTypes;
}
const Ppt = /*#__PURE__*/React.forwardRef(function Ppt(_ref104, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref104;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Ppt.propTypes = iconPropTypes;
}
const PresentationFile = /*#__PURE__*/React.forwardRef(function PresentationFile(_ref105, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref105;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PresentationFile.propTypes = iconPropTypes;
}
const Pressure = /*#__PURE__*/React.forwardRef(function Pressure(_ref106, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref106;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Pressure.propTypes = iconPropTypes;
}
const PressureFilled = /*#__PURE__*/React.forwardRef(function PressureFilled(_ref107, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref107;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PressureFilled.propTypes = iconPropTypes;
}
const PreviousFilled = /*#__PURE__*/React.forwardRef(function PreviousFilled(_ref108, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref108;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
    "data-icon-path": "inner-path"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PreviousFilled.propTypes = iconPropTypes;
}
const PreviousOutline = /*#__PURE__*/React.forwardRef(function PreviousOutline(_ref109, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref109;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PreviousOutline.propTypes = iconPropTypes;
}
const Printer = /*#__PURE__*/React.forwardRef(function Printer(_ref110, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref110;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Printer.propTypes = iconPropTypes;
}
const Product = /*#__PURE__*/React.forwardRef(function Product(_ref111, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref111;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H14V20H8zM8 22H18V24H8z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Product.propTypes = iconPropTypes;
}
const ProgressBar = /*#__PURE__*/React.forwardRef(function ProgressBar(_ref112, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref112;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H20V17H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ProgressBar.propTypes = iconPropTypes;
}
const ProgressBarRound = /*#__PURE__*/React.forwardRef(function ProgressBarRound(_ref113, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref113;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ProgressBarRound.propTypes = iconPropTypes;
}
const Promote = /*#__PURE__*/React.forwardRef(function Promote(_ref114, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref114;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21L17.4 22.4 14.8 25 23 25 23 27 14.8 27 17.4 29.6 16 31 11 26z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 19H17.6V21H6.3z",
    transform: "rotate(-45.001 12 20)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22h-2v-5c0-0.3,0.1-0.5,0.3-0.7l4.1-4.1c1.7-1.7,2.6-4,2.6-6.4V4h-1.9c-2.4,0-4.7,0.9-6.4,2.6l-4.1,4.1 C15.5,10.9,15.3,11,15,11H7.5l-2.6,3.3l5.3,0.8l-0.3,2l-7-1c-0.4-0.1-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l4-5C6.4,9.1,6.7,9,7,9h7.6 l3.8-3.8C20.4,3.1,23.2,2,26.1,2H28c1.1,0,2,0.9,2,2v1.9c0,2.9-1.1,5.7-3.2,7.8L23,17.4V22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Promote.propTypes = iconPropTypes;
}
const PromptSession = /*#__PURE__*/React.forwardRef(function PromptSession(_ref115, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref115;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.5859L25 23.5859 25 21 23 21 23 24.4141 25.5859 27 27 25.5859z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31c-3.8599 0-7-3.1401-7-7s3.1401-7 7-7 7 3.1401 7 7-3.1401 7-7 7zm0-12c-2.7571 0-5 2.2429-5 5s2.2429 5 5 5 5-2.2429 5-5-2.2429-5-5-5zM28 15h2V5c0-1.103-.8975-2-2-2h-3v2h3v10z"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "13",
    r: "2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "13",
    r: "2"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "m7,23h-3c-1.103,0-2-.8975-2-2V5c0-1.103.897-2,2-2h3v2h-3v16h3v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PromptSession.propTypes = iconPropTypes;
}
const PropertyRelationship = /*#__PURE__*/React.forwardRef(function PropertyRelationship(_ref116, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref116;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16L22 24 20.6 22.6 27.2 16 20.6 9.4 22 8zM12 15H20V17H12zM2 16L10 8 11.4 9.4 4.8 16 11.4 22.6 10 24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  PropertyRelationship.propTypes = iconPropTypes;
}
const Purchase = /*#__PURE__*/React.forwardRef(function Purchase(_ref117, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref117;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H16V22H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Purchase.propTypes = iconPropTypes;
}
const WatsonHealthQcLaunch = /*#__PURE__*/React.forwardRef(function WatsonHealthQcLaunch(_ref118, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref118;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22H19a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h6v2H19V20h6zM13 8H9a2.002 2.002 0 00-2 2V20a2.0023 2.0023 0 002 2h1v2a2.0023 2.0023 0 002 2h2V24H12V22h1a2.0023 2.0023 0 002-2V10A2.002 2.002 0 0013 8zM9 20V10h4V20z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,28,30ZM4,4V28H28V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthQcLaunch.propTypes = iconPropTypes;
}
const QqPlot = /*#__PURE__*/React.forwardRef(function QqPlot(_ref119, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref119;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "4",
    r: "2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "12",
    r: "2"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "7",
    r: "2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QqPlot.propTypes = iconPropTypes;
}
const QrCode = /*#__PURE__*/React.forwardRef(function QrCode(_ref120, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref120;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H26V28H24z",
    transform: "rotate(-90 25 27)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H20V24H18z",
    transform: "rotate(-90 19 23)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23H29V25H25z",
    transform: "rotate(-90 27 24)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H21V21H19z",
    transform: "rotate(-90 20 19)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H10V26H6z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M14,14H2V2H14ZM4,12h8V4H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QrCode.propTypes = iconPropTypes;
}
const QuadrantPlot = /*#__PURE__*/React.forwardRef(function QuadrantPlot(_ref121, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref121;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M5 30a3 3 0 113-3A3.0033 3.0033 0 015 30zm0-4a1 1 0 101 1A1.001 1.001 0 005 26zM8 8a3 3 0 113-3A3.0033 3.0033 0 018 8zM8 4A1 1 0 109 5 1.001 1.001 0 008 4zM22 13a3 3 0 113-3A3.0033 3.0033 0 0122 13zm0-4a1 1 0 101 1A1.001 1.001 0 0022 9z"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "2"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "21",
    r: "2"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "2"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "28",
    r: "2"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "24",
    r: "2"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "11",
    r: "2"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "4",
    r: "2"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QuadrantPlot.propTypes = iconPropTypes;
}
const Query = /*#__PURE__*/React.forwardRef(function Query(_ref122, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref122;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "11",
    cy: "15.5",
    r: "1.5"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Query.propTypes = iconPropTypes;
}
const QueryQueue = /*#__PURE__*/React.forwardRef(function QueryQueue(_ref123, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref123;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QueryQueue.propTypes = iconPropTypes;
}
const Queued = /*#__PURE__*/React.forwardRef(function Queued(_ref124, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref124;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Queued.propTypes = iconPropTypes;
}
const Quotes = /*#__PURE__*/React.forwardRef(function Quotes(_ref125, ref) {
  let {
    children,
    size = 16,
    ...rest
  } = _ref125;
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Quotes.propTypes = iconPropTypes;
}

export { OverflowMenuHorizontal, OverflowMenuVertical, Overlay, Package, PackageTextAnalysis, PageBreak, PageFirst, PageLast, PageNumber, PaintBrush, PaintBrushAlt, PalmTree, PanHorizontal, PanVertical, PanelExpansion, Paragraph, Parameter, ParentChild, PartitionAuto, PartitionCollection, PartitionRepartition, PartitionSame, PartitionSpecific, PartlyCloudy, PartlyCloudyNight, Partnership, PassengerDrinks, PassengerPlus, Password, Paste, Pause, PauseFilled, PauseFuture, PauseOutline, PauseOutlineFilled, PausePast, PcnENode, PcnMilitary, PcnPNode, PcnZNode, Pdf, PdfReference, Pedestrian, PedestrianChild, PedestrianFamily, Pen, PenFountain, Pending, PendingFilled, Percentage, PercentageFilled, Person, PersonFavorite, Pest, Phone, PhoneApplication, PhoneBlock, PhoneBlockFilled, PhoneFilled, PhoneIncoming, PhoneIncomingFilled, PhoneIp, PhoneOff, PhoneOffFilled, PhoneOutgoing, PhoneOutgoingFilled, PhoneSettings, PhoneVoice, PhoneVoiceFilled, PhraseSentiment, PicnicArea, PiggyBank, PiggyBankSlot, Pills, PillsAdd, PillsSubtract, Pin, PinFilled, Plan, Plane, PlanePrivate, PlaneSea, Play, PlayFilled, PlayFilledAlt, PlayOutline, PlayOutlineFilled, Playlist, Plug, PlugFilled, Png, PointOfPresence, Police, Policy, Popup, PortInput, PortOutput, Portfolio, Power, Ppt, PresentationFile, Pressure, PressureFilled, PreviousFilled, PreviousOutline, Printer, Product, ProgressBar, ProgressBarRound, Promote, PromptSession, PropertyRelationship, Purchase, QqPlot, QrCode, QuadrantPlot, Query, QueryQueue, Queued, Quotes, WatsonHealthPageScroll, WatsonHealthPetImageB, WatsonHealthPetImageO, WatsonHealthPointerText, WatsonHealthQcLaunch };
